import axios from 'axios';
import { getApiUrl } from '@/config/api';
import authService from '@/shared/services/auth';

class CatGrupoMaterialService {
  constructor() {
    this.grupoMateriales = [];
    this.loading = false;
    this.error = null;
    this.selectedEmpresa = null;
  }

  async initialize() {
    // Esperar un poco para que la empresa se seleccione
    await this.waitForEmpresa();
    await this.listar();
  }

  // Esperar a que la empresa esté seleccionada
  async waitForEmpresa() {
    let attempts = 0;
    const maxAttempts = 50; // 5 segundos máximo
    
    while (attempts < maxAttempts) {
      this.selectedEmpresa = authService.getSelectedEmpresa();
      if (this.selectedEmpresa && this.selectedEmpresa.EmpresaId) {
        console.log('Empresa encontrada para CatGrupoMaterial:', this.selectedEmpresa);
        return;
      }
      
      // Esperar 100ms antes del siguiente intento
      await new Promise(resolve => setTimeout(resolve, 100));
      attempts++;
    }
    
    // Si no se encuentra empresa después de los intentos
    this.error = 'No se pudo obtener la empresa seleccionada';
    console.error('No se pudo obtener empresa para CatGrupoMaterial después de', maxAttempts, 'intentos');
  }

  async listar() {
    this.loading = true;
    this.error = null;
    
    try {
      // Verificar que tenemos empresa seleccionada
      if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
        this.selectedEmpresa = authService.getSelectedEmpresa();
        if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
          this.loading = false;
          return { success: false, data: [], message: 'Debe elegir una empresa antes de poder continuar.' };
        }
      }

      const token = authService.getToken();
      const response = await axios.post(getApiUrl('/api/CatGrupoMaterial/listar'), {
        EmpresaId: this.selectedEmpresa.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      
      // Filtrar por empresa en el frontend como medida de seguridad adicional
      const allGrupoMateriales = response.data || [];
      this.grupoMateriales = allGrupoMateriales.filter(grupoMateriale => grupoMateriale.EmpresaId === this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('GrupoMateriales cargados:', this.grupoMateriales.length, 'de', allGrupoMateriales.length, 'total');
      console.log('Empresa del usuario:', this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Grupos de Materiales cargados:', this.grupoMateriales.length);
      
      return {
        success: true,
        data: this.grupoMateriales,
        message: 'Grupos de Materiales cargados exitosamente'
      };
    } catch (error) {
      console.error('Error al cargar Grupos de Materiales:', error);
      this.error = error.message;
      this.grupoMateriales = [];
      this.loading = false;
      throw error;
    }
  }

  async guardar(grupoMaterialData) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...grupoMaterialData,
        EmpresaId: selectedEmpresa?.EmpresaId || grupoMaterialData.EmpresaId
      };

      const response = await axios.post(getApiUrl('/api/CatGrupoMaterial/guardar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Grupo de Material guardado exitosamente'
      };
    } catch (error) {
      console.error('Error al guardar Grupo de Material:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al guardar Grupo de Material'
      };
    }
  }

  async borrar(grupoMaterialData) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const dataToSend = {
        ...grupoMaterialData,
        EmpresaId: selectedEmpresa?.EmpresaId || grupoMaterialData.EmpresaId
      };

      const response = await axios.post(getApiUrl('/api/CatGrupoMaterial/borrar'), dataToSend, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Grupo de Material eliminado exitosamente'
      };
    } catch (error) {
      console.error('Error al eliminar Grupo de Material:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al eliminar Grupo de Material'
      };
    }
  }

  async lectura(clave) {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatGrupoMaterial/lectura'), {
        Clave: clave,
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error al leer Grupo de Material:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al leer Grupo de Material'
      };
    }
  }

  async recargar() {
    await this.listar();
  }

  async downloadBulk() {
    try {
      const token = authService.getToken();
      const selectedEmpresa = authService.getSelectedEmpresa();
      
      const response = await axios.post(getApiUrl('/api/CatGrupoMaterial/descarga-masiva'), {
        EmpresaId: selectedEmpresa?.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      });

      // Crear enlace de descarga
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `grupos_materiales_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return {
        success: true,
        message: 'Descarga iniciada correctamente'
      };
    } catch (error) {
      console.error('Error al descargar Grupos de Materiales:', error);
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al descargar Grupos de Materiales'
      };
    }
  }
}

export default CatGrupoMaterialService;
